import { db } from '../config/firebase';
import { collection, query, where, orderBy, limit, onSnapshot, getDocs, doc, updateDoc } from 'firebase/firestore';

const COLLECTIONS = {
  admin: 'notifications_admin',
  partner: 'notifications_partner',
  manager: 'notifications_manager'
};

export const listenToNotifications = (userId, role, callback) => {
  const collectionName = COLLECTIONS[role] || 'notifications_admin';
  const q = query(
    collection(db, collectionName),
    where('userId', '==', userId),
    orderBy('createdAt', 'desc'),
    limit(50)
  );
  return onSnapshot(q, (snapshot) => {
    const notifications = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    callback(notifications);
  });
};

export const getNotifications = async (userId, role) => {
  const collectionName = COLLECTIONS[role] || 'notifications_admin';
  const q = query(
    collection(db, collectionName),
    where('userId', '==', userId),
    orderBy('createdAt', 'desc'),
    limit(50)
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
};

export const markAsRead = async (notificationId, role) => {
  const collectionName = COLLECTIONS[role] || 'notifications_admin';
  await updateDoc(doc(db, collectionName, notificationId), { read: true });
};
